import axios from 'axios';

let prefix = "/user-saga"

const UserSagaApi = {

	getSagaRewardsList(payload) {
		return axios.get(prefix + "/get-rewards-list", { params: payload })
	},
}

export default UserSagaApi;